import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import GoogleCircleFilledSvg from "@ant-design/icons-svg/es/asn/GoogleCircleFilled";
import AntdIcon from "../components/AntdIcon";
var GoogleCircleFilled = function GoogleCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: GoogleCircleFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  GoogleCircleFilled.displayName = 'GoogleCircleFilled';
}
export default /*#__PURE__*/React.forwardRef(GoogleCircleFilled);